import { SaveDocumentRequest } from '../model/transport-document';
import { Observable } from 'rxjs';
import { Document } from '../model/document';
import { Injectable } from '@angular/core';
import { AppClientConfiguration, AppServerAPI } from '@sdbn/common';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {

  constructor(
    private appServerAPI: AppServerAPI,
    private appClientConfiguration: AppClientConfiguration) { }

  public createDocument(templateId: number): Observable<Document> {
    return this.appServerAPI.execute<Document>('/client/document/create', { templateId });
  }

  public saveDocuments(transportDocuments: SaveDocumentRequest[]): Observable<Document> {
    return this.appServerAPI.execute<Document>('/client/document/save', transportDocuments);
  }

  public getDocuments(documentIds: number[]): Observable<Document[]> {
    return this.appServerAPI.execute<Document[]>('/client/document/get', documentIds);
  }
}
